import React from 'react'

import * as Styled from './Default.styles'

const CountdownTimer = ({ timeLeft }) => {
  const { days, hours, minutes } = timeLeft
  const hoursWithLeadingZero = hours?.toString()?.padStart(2, '0')
  const minutesWithLeadingZero = minutes?.toString()?.padStart(2, '0')

  return (
    <Styled.Wrapper>
      {days}:{hoursWithLeadingZero}:{minutesWithLeadingZero}
    </Styled.Wrapper>
  )
}

export default CountdownTimer
